var map = {
	"./ad.svg": "188e",
	"./adopt-vip.svg": "9867",
	"./agreed.svg": "afbb",
	"./back-home.svg": "e929",
	"./barrage-vip.svg": "740c",
	"./biaoqing.svg": "4564",
	"./bless_vip.svg": "07ab",
	"./consume.svg": "2d68",
	"./consume1.svg": "7f1a",
	"./danmu.svg": "a840",
	"./douyin.svg": "34de",
	"./drink-game.svg": "4782",
	"./effict.svg": "2b60",
	"./expression-vip.svg": "7362",
	"./gift.svg": "640b",
	"./gift_vip.svg": "7ffc",
	"./hurry.svg": "34bf",
	"./is-top.svg": "8be7",
	"./maiba.svg": "64ad",
	"./maibatx.svg": "2ffe",
	"./mv-vip-icon.svg": "2848",
	"./mv-vip.svg": "6bed",
	"./mv_vip.svg": "7924",
	"./my-like.svg": "7e0f",
	"./new-song.svg": "eadd",
	"./no-ad.svg": "738e",
	"./no-agreed.svg": "810e",
	"./often.svg": "f4e9",
	"./photo_vip.svg": "a470",
	"./plus.svg": "0826",
	"./plus1.svg": "0b3b",
	"./rights-dadie.svg": "d41e",
	"./rights-dj.svg": "09f1",
	"./rights-geshen.svg": "928b",
	"./rights-wuqu.svg": "eefd",
	"./room.svg": "cd96",
	"./save-order.svg": "be12",
	"./vip-adopt.svg": "36ff",
	"./vip-bless.svg": "16a2",
	"./vip-gift.svg": "c072",
	"./vip-photo.svg": "4381",
	"./vip_barrage.svg": "8fd4",
	"./vip_bless.svg": "aa09",
	"./vip_drink.svg": "7383",
	"./vip_expression.svg": "4da9",
	"./vip_gift.svg": "131d",
	"./vip_mv.svg": "26c9",
	"./vip_photo.svg": "1f40",
	"./vip_video.svg": "eb75",
	"./your-gift.svg": "5544"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ac3";